module.exports = __webpack_public_path__ + "static/img/reset.e814727f.png";